import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './contex/AuthProvider';
import  { Toaster } from 'react-hot-toast';
import{QueryClient,QueryClientProvider,useQuery} from "@tanstack/react-query"
const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClinet = new QueryClient()
root.render(
  <React.StrictMode>
   <QueryClientProvider client={queryClinet}>
   <AuthProvider>
   <App/>
   </AuthProvider>
   <Toaster/>
   </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
